import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ApplicationStageCStates {
  application_uuid: string | undefined,
}

const initialState: ApplicationStageCStates = {
  application_uuid: undefined,
};

const ApplicationStageCSlice = createSlice({
  name: "Application Stage C Slice",
  initialState,
  reducers: {
    updateStageCApplicationUUID: (state, action: PayloadAction<string>) => {
      state.application_uuid = action.payload;
    },
    resetStageCStates:(state) =>{
      state.application_uuid = undefined;
    }
  },
  extraReducers: {},
});

export const { updateStageCApplicationUUID, resetStageCStates } = ApplicationStageCSlice.actions;

export default ApplicationStageCSlice.reducer;
